var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");
var ui_extensions = require("ui-extensions");

/**
 * Created by karel on 19/08/14.
 */
var TangentHandleModel = function (segmentModel, pointHandleModel, member, primary) {
    var self = this;
    this.makeObservableTreeNode();

    this.segmentModel = segmentModel;
    this.pathInteractionModel = this.segmentModel.pathInteractionModel;
    this.pointHandleModel = pointHandleModel;

    this.coord = this.value("coord", true);
    this.selected = this.value("interactionSelected", true);
    this.symmetrical = this.value("symmetrical", true);

    this.neighbourSegmentModel = this.value("neighbourSegmentModel", false);
    this.neighbourTangentHandleModel = this.value("neighbourTangentHandleModel", false);

    this.primary = primary;

    this.member = member;

    this.coord(this.member().copy());

    this.coord.onChange("interaction_model_coupling",function(){
        if (self.isAlive()) {
            if(!self.coord().eq(self.member()))
                self.member(self.coord().copy());
        }
    },10);

    this.member.onChange("interaction_model_coupling",function(){
        if (self.isAlive()) {
            if(!self.coord().eq(self.member()))
                self.coord(self.member().copy());
        }
    },10);

    this.selected.onChange("selected_infocus", function(value) {
        if(self.isAlive() && self.pathInteractionModel.isAlive()) {
            self.pathInteractionModel.infocus(value);
            self.segmentModel.infocus(value);
        }
    },10);

    this.showSymmetrical = this.shadow("showSymmetrical",
        function() {
            return self.symmetrical();
        }, function(value) {
            if(value)
                self.converToSymmetrical();
            else
                self.converToNonSymmetrical();
        }, [self.symmetrical]);

    this.neighbourTangentHandleModel.onChange(self, function() {
        self.symmetrical(self.isSymmetrical());
    });

    this.onInit("onInit", this.initialize, 10);
};
lib_core.mixin(TangentHandleModel, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(TangentHandleModel, "TangentHandleModel");
module.exports = TangentHandleModel;

TangentHandleModel.prototype.initialize = function() {
    this.symmetrical(this.isSymmetrical());
};

TangentHandleModel.prototype.getSnapSet = function () {
    var self = this;
    var result = new editor_2d.SnapSet();

    result.addHor(self.coord(), 1);
    result.addVer(self.coord(), 1);

    return result;
};

TangentHandleModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

TangentHandleModel.prototype.move = function (vec) {
    this.coord(this.coord().add(vec));
    if(this.symmetrical() && this.neighbourTangentHandleModel()) {
        this.neighbourTangentHandleModel().coord(this.coord().flip(this.pointHandleModel.coord()));
    }
};

TangentHandleModel.prototype.isSymmetrical = function () {
    if(this.neighbourTangentHandleModel()) {
        var tan_1_r = this.coord().sub(this.pointHandleModel.coord());
        var tan_0_r = this.neighbourTangentHandleModel().coord().sub(this.pointHandleModel.coord());
        var diff_r = tan_0_r.add(tan_1_r).length() / tan_1_r.sub(tan_0_r).length();
         if (diff_r < 0.01) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

TangentHandleModel.prototype.getInspectorElements = function () {
    var inspector_elements = this.parent().getInspectorElements();

    if(this.neighbourTangentHandleModel()) {
        inspector_elements.input_elements.push(
            {
                label       : 'Smooth',
                type        : ui_extensions.InspectorInputType.CHECKBOX,
                datamember  : this.showSymmetrical
            });
    }
    inspector_elements.help_elements['name'] = 'Bezier Tangent Point';
    return inspector_elements;
};

TangentHandleModel.prototype.converToNonSymmetrical = function() {
    var neighbour = this.neighbourTangentHandleModel();
    if(neighbour) {
        this.symmetrical(false);
        neighbour.symmetrical(false);
        neighbour.coord(neighbour.coord().rotate(10, this.pointHandleModel.coord()));
    }
};

TangentHandleModel.prototype.converToSymmetrical = function() {
    var neighbour = this.neighbourTangentHandleModel();
    if(neighbour) {
        this.symmetrical(true);
        neighbour.symmetrical(true);
        neighbour.coord(this.coord().flip(this.pointHandleModel.coord()));
    }
};

TangentHandleModel.prototype.doubleClickAction = function (coord, subelement) {
    if(this.symmetrical()) {
        this.converToNonSymmetrical();
    } else {
        this.converToSymmetrical();
    }
};
